import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CategoryWifiProfileEffects } from './category-wifi-profile-configuration.effects';
import { categoryWifiProfileReducer } from './category-wifi-profile-configuration.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('categoryWifiProfile', categoryWifiProfileReducer),
    EffectsModule.forFeature([CategoryWifiProfileEffects]),
  ],
  providers: [],
})
export class CategoryWifiProfileStoreModule {}
